import { BaseRequest } from "../../../../base/request/BaseRequest";

/** Request del paso 3: cambia la contraseña usando el `resetToken` obtenido en
 *  el paso 2. La confirmación de contraseña es UI-only y no viaja acá — vive en
 *  el modelo de formulario de la card. */
export type RestablecerPasswordRequest = BaseRequest & {
  /** Token de un solo uso devuelto por `verificar-codigo`. */
  resetToken: string;
  /** Contraseña nueva (8–100, al menos una letra y un dígito). */
  password: string;
};

export const fx_createRestablecerPasswordRequest = (
  resetToken: string,
  password: string,
): RestablecerPasswordRequest => {
  return {
    resetToken,
    password,
  };
};
